/* ==========================================================================
   ss-motion.js · salt&spirit. · pliego §2.12 + §3.2 (ciclo de vida del swap) + §11 #16
   Vanilla, defer, sin librerías. Todo el inventario de movimiento:
     · nav .is-scrolled (≥169 px D / ≥159 px M, 300 ms --ez-nav)
     · reveals one-shot (IO threshold 0, unobserve) + Ken Burns de S04 al entrar
     · decode() del bodegón antes de soltar la coreografía de carga (la coreografía en sí es CSS)
     · parallax del hero 0.90/1.00/1.30/1.30/1.30/1.50/1.80 (solo con el hero en viewport; <810 px a 0.45 de intensidad desde 2-oct)
     · scrub de S04 (0.22 + 0.78p, suavizado 0.16, reversible, sin sticky)
     · barra del ritual (40vh, translateY(scrollY − trackTop))
     · sello en <canvas> (R 120, paso 2π/n uniforme, 20 °/s ligado a deltaTime)
     · 4 marquesinas (50 px/s, --D medido, pausa fuera de viewport, arrastre 1:1, pausa hover/focus/toque en T0)
     · acordeones (window.ssAcc: height 525 ms --ez-critical; FAQ 560 ms --ez-hover; no exclusivos)
     · data-ss-pos → gtag('event','ss_cta',{pos}) solo si existe gtag
     · prefers-reduced-motion: todo quieto, reacciona al cambio
   API global (idempotente; cada componente se marca con data-ss-ready):
     window.ssMotionInit(root) · window.ssMotionTeardown(root)
     window.ssInit(root) / window.ssTeardown(root): envuelven las que ya existan (ss-subscribe.js carga antes)
     window.ssAcc(btn)
   La galería de ss-buy (3806 ms) la mueve ss-subscribe.js (window.ssBuyInit), no este archivo.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__ssMotion) return;
  window.__ssMotion = true;

  var doc = document;
  var html = doc.documentElement;
  /* idempotente: si algo quitó .ss-js antes de que llegara este archivo, los estados iniciales vuelven a colgar de él */
  html.classList.add('ss-js');
  /* QA r2: el scroll suave de anclas se enciende tras «load» (ver ss-motion.css) */
  if (doc.readyState === 'complete') html.classList.add('ss-loaded');
  else window.addEventListener('load', function () { setTimeout(function () { html.classList.add('ss-loaded'); }, 0); });
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MQ_M = window.matchMedia('(max-width: 679px)');
  var MQ_PAR = window.matchMedia('(min-width: 810px)');
  var registry = [];

  function reduced() { return RM.matches; }
  function $$(root, sel) {
    var out = [];
    if (!root) return out;
    if (root.nodeType === 1 && root.matches && root.matches(sel)) out.push(root);
    var list = root.querySelectorAll ? root.querySelectorAll(sel) : [];
    for (var i = 0; i < list.length; i++) out.push(list[i]);
    return out;
  }
  function pageTop(el) {
    var y = 0;
    while (el) { y += el.offsetTop || 0; el = el.offsetParent; }
    return y;
  }
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function register(el, key, stop) {
    el.setAttribute('data-ss-ready', (el.getAttribute('data-ss-ready') ? el.getAttribute('data-ss-ready') + ' ' : '') + key);
    registry.push({ el: el, key: key, stop: stop });
  }
  function unready(el, key) {
    var v = (el.getAttribute('data-ss-ready') || '').split(' ').filter(function (k) { return k && k !== key; });
    if (v.length) el.setAttribute('data-ss-ready', v.join(' ')); else el.removeAttribute('data-ss-ready');
  }
  function isReady(el, key) {
    var v = el.getAttribute('data-ss-ready');
    return !!v && (' ' + v + ' ').indexOf(' ' + key + ' ') > -1;
  }
  function onMQ(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn); else mq.addListener(fn);
    return function () { if (mq.removeEventListener) mq.removeEventListener('change', fn); else mq.removeListener(fn); };
  }
  function cssVar(name, fallback) {
    var v = getComputedStyle(html).getPropertyValue(name);
    return (v && v.trim()) || fallback;
  }

  /* ------------------------------------------------------------------ nav */
  var navBound = false;
  function initNav() {
    if (navBound) return;
    navBound = true;
    var ticking = false;
    function apply() {
      ticking = false;
      var th = MQ_M.matches ? 159 : 169;
      var on = (window.scrollY || window.pageYOffset) >= th;
      var headers = doc.querySelectorAll('.section-header');
      for (var i = 0; i < headers.length; i++) headers[i].classList.toggle('is-scrolled', on);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    onMQ(MQ_M, apply);
    apply();
  }

  /* ------------------------------------------------------------ data-ss-pos */
  var posBound = false;
  function initPos() {
    if (posBound) return;
    posBound = true;
    doc.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-ss-pos]') : null;
      if (!el) return;
      if (typeof window.gtag === 'function') {
        try { window.gtag('event', 'ss_cta', { pos: el.getAttribute('data-ss-pos') }); } catch (err) { /* sin GA */ }
      }
    }, true);
  }

  /* -------------------------------------------------------------- reveals */
  var revealIO = null;
  function getRevealIO() {
    if (revealIO) return revealIO;
    if (!('IntersectionObserver' in window)) return null;
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        revealIO.unobserve(el);
        playReveal(el);
      });
    }, { threshold: 0, rootMargin: '0px' });
    return revealIO;
  }
  function playReveal(el) {
    el.classList.add('is-in');
    if (el.classList.contains('ss-reveal')) {
      var ms = reduced() ? 250 : (el.getAttribute('data-ss-reveal') === 'intro' ? 1150 : 1600);
      el.__ssDone = setTimeout(function () { el.classList.add('is-done'); }, ms);
    }
  }
  function initReveals(root) {
    var els = $$(root, '.ss-reveal, [data-ss-kenburns]');
    var io = getRevealIO();
    els.forEach(function (el) {
      if (isReady(el, 'rv')) return;
      if (el.classList.contains('is-in')) { register(el, 'rv', function () {}); return; }
      if (!io) { playReveal(el); register(el, 'rv', function () {}); return; }
      io.observe(el);
      register(el, 'rv', function () {
        io.unobserve(el);
        if (el.__ssDone) clearTimeout(el.__ssDone);
      });
    });
  }

  /* ------------------------------------------------ hero: decode + parallax */
  function initHero(root) {
    $$(root, '[data-ss-hero]').forEach(function (hero) {
      if (isReady(hero, 'hero')) return;
      var dead = false;
      /* 1) no arrancar el muelle del bodegón hasta decode() (con tope de 2.5 s) */
      if (!hero.classList.contains('is-decoded')) {
        var imgs = $$(hero, '[data-ss-load="product"] img, [data-ss-load="floaters"] img');
        var done = false;
        var release = function () {
          if (done || dead) return;
          done = true;
          hero.classList.add('is-decoded');
        };
        var cap = setTimeout(release, 2500);
        Promise.all(imgs.map(function (img) {
          if (img.decode) return img.decode().catch(function () {});
          return Promise.resolve();
        })).then(function () { clearTimeout(cap); release(); });
      }
      /* 2) parallax por sobre: translateY extra = (1 − ratio) · scrollY en la capa exterior */
      var items = $$(hero, '[data-ss-parallax]').map(function (el) {
        return { el: el, k: 1 - (parseFloat(el.getAttribute('data-ss-parallax')) || 1) };
      });
      var inView = true;
      var raf = 0;
      function apply() {
        raf = 0;
        /* 2-oct: también en celular (Owen), a 0.45 de intensidad para que los sobres no crucen el botón */
        var on = !reduced();
        var f = MQ_PAR.matches ? 1 : 0.45;
        var y = window.scrollY || window.pageYOffset;
        items.forEach(function (it) {
          it.el.style.translate = on && it.k ? '0 ' + (it.k * f * y).toFixed(2) + 'px' : '';
        });
      }
      function onScroll() { if (inView && !raf) raf = requestAnimationFrame(apply); }
      var io = null;
      if (items.length && 'IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) {
          inView = es[es.length - 1].isIntersecting;
          if (inView) onScroll();
        }, { threshold: 0 });
        io.observe(hero);
      }
      if (items.length) window.addEventListener('scroll', onScroll, { passive: true });
      var offMQ = onMQ(MQ_PAR, apply);
      if (items.length) apply();
      register(hero, 'hero', function () {
        dead = true;
        if (io) io.disconnect();
        window.removeEventListener('scroll', onScroll);
        offMQ();
        if (raf) cancelAnimationFrame(raf);
        items.forEach(function (it) { it.el.style.translate = ''; });
      });
    });
  }

  /* -------------------------------------------------------- scrub de S04 */
  function initScrub(root) {
    $$(root, '[data-ss-scrub]').forEach(function (el) {
      if (isReady(el, 'scrub')) return;
      function num(attr, def) {
        var v = el.getAttribute(attr);
        return v === null || v === '' ? def : parseFloat(v);
      }
      var cur = null;
      var raf = 0;
      var active = false;
      el.style.transformOrigin = '50% 50%';
      function target() {
        var m = MQ_M.matches;
        var TX = m ? num('data-tx-m', 0) : num('data-tx', -100);
        var TY = m ? num('data-ty-m', -460) : num('data-ty', -340);
        var len = el.offsetHeight || 1;
        var y0 = pageTop(el) - window.innerHeight;
        var p = reduced() ? 1 : clamp01(((window.scrollY || window.pageYOffset) - y0) / len);
        return { s: 0.22 + 0.78 * p, x: TX * (1 - p), y: TY * (1 - p) };
      }
      function paint(v) {
        el.style.translate = v.x.toFixed(2) + 'px ' + v.y.toFixed(2) + 'px';
        el.style.scale = v.s.toFixed(5);
      }
      function frame() {
        raf = 0;
        var t = target();
        if (!cur || reduced()) cur = { s: t.s, x: t.x, y: t.y };
        else {
          cur.s += (t.s - cur.s) * 0.16;
          cur.x += (t.x - cur.x) * 0.16;
          cur.y += (t.y - cur.y) * 0.16;
        }
        paint(cur);
        var moving = Math.abs(t.s - cur.s) > 0.0005 || Math.abs(t.y - cur.y) > 0.05 || Math.abs(t.x - cur.x) > 0.05;
        if (active && moving) raf = requestAnimationFrame(frame);
      }
      function kick() { if (!raf) raf = requestAnimationFrame(frame); }
      function onScroll() { if (active) kick(); }
      var io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) {
          active = es[es.length - 1].isIntersecting;
          if (active) kick();
          else { cur = target(); paint(cur); }
        }, { threshold: 0, rootMargin: '200px 0px' });
        io.observe(el.parentElement || el);
      } else { active = true; }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', kick);
      cur = target();
      paint(cur);
      register(el, 'scrub', function () {
        if (io) io.disconnect();
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', kick);
        if (raf) cancelAnimationFrame(raf);
        el.style.translate = '';
        el.style.scale = '';
      });
    });
  }

  /* ------------------------------------------------ barra del ritual (S02) */
  function initTrack(root) {
    $$(root, '[data-ss-ritual-track], [data-ss-track]').forEach(function (track) {
      if (isReady(track, 'track')) return;
      var fill = track.querySelector('[data-ss-ritual-fill], [data-ss-fill]');
      if (!fill) return;
      var raf = 0;
      var active = false;
      function apply() {
        raf = 0;
        if (reduced()) {
          fill.style.translate = '';
          fill.style.height = '100%';
          return;
        }
        fill.style.height = '';
        var y = (window.scrollY || window.pageYOffset) - pageTop(track);
        fill.style.translate = '0 ' + y.toFixed(1) + 'px';
      }
      function onScroll() { if (active && !raf) raf = requestAnimationFrame(apply); }
      var io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) {
          active = es[es.length - 1].isIntersecting;
          if (active) onScroll();
        }, { threshold: 0 });
        io.observe(track);
      } else { active = true; }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      apply();
      register(track, 'track', function () {
        if (io) io.disconnect();
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        if (raf) cancelAnimationFrame(raf);
        fill.style.translate = '';
        fill.style.height = '';
      });
    });
  }

  /* ------------------------------------------------------------ sello */
  function initSeal(root) {
    $$(root, '[data-ss-seal]').forEach(function (box) {
      if (isReady(box, 'seal')) return;
      var canvas = box.tagName === 'CANVAS' ? box : box.querySelector('canvas');
      if (!canvas || !canvas.getContext) return;
      var ctx = canvas.getContext('2d');
      var TEXT = box.getAttribute('data-text') || canvas.getAttribute('data-text') || 'hydrate your spirit. • sin azúcar • keto • ayuno • ';
      var SIZE = 300;
      var CENTER = 150;
      var RADIUS = 120;
      var FONT = '500 25px "Fustat", "Fustat Fallback Text", sans-serif';
      var DEG_S = 20;
      canvas.width = SIZE;
      canvas.height = SIZE;
      var ang = 0;
      var prev = 0;
      var raf = 0;
      var active = false;
      var dead = false;
      function draw(a) {
        var n = TEXT.length;
        var step = (Math.PI * 2) / n;
        ctx.clearRect(0, 0, SIZE, SIZE);
        ctx.save();
        ctx.translate(CENTER, CENTER);
        ctx.rotate(a);
        ctx.font = FONT;
        ctx.fillStyle = '#ffffff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        for (var i = 0; i < n; i++) {
          var t = i * step;
          ctx.save();
          ctx.translate(RADIUS * Math.sin(t), -RADIUS * Math.cos(t));
          ctx.rotate(t);
          ctx.fillText(TEXT.charAt(i), 0, 0);
          ctx.restore();
        }
        ctx.restore();
      }
      function loop(now) {
        raf = 0;
        if (!active || dead || reduced()) return;
        if (prev) ang += (DEG_S * Math.PI / 180) * ((now - prev) / 1000);
        prev = now;
        draw(ang);
        raf = requestAnimationFrame(loop);
      }
      function start() {
        if (dead) return;
        draw(ang);
        if (active && !reduced() && !raf) { prev = 0; raf = requestAnimationFrame(loop); }
      }
      var io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) {
          active = es[es.length - 1].isIntersecting;
          if (active) start();
          else if (raf) { cancelAnimationFrame(raf); raf = 0; }
        }, { threshold: 0 });
        io.observe(box);
      } else { active = true; }
      draw(0);
      if (doc.fonts && doc.fonts.load) doc.fonts.load(FONT).then(start, start); else start();
      register(box, 'seal', function () {
        dead = true;
        if (io) io.disconnect();
        if (raf) cancelAnimationFrame(raf);
      });
    });
  }

  /* ---------------------------------------------------------- marquesinas */
  function initMarquees(root) {
    $$(root, '[data-ss-marquee], [data-ss-tk]').forEach(function (box) {
      if (isReady(box, 'tk')) return;
      var track = null;
      for (var c = 0; c < box.children.length; c++) {
        var ch = box.children[c];
        if (ch.classList.contains('ss-tk__list') || ch.classList.contains('ss-tk__track')) { track = ch; break; }
      }
      if (!track) return;
      var dirAttr = box.getAttribute('data-ss-dir') || box.getAttribute('data-dir') || 'left';
      var right = dirAttr === 'right' || dirAttr === '1';
      var speed = parseFloat(box.getAttribute('data-ss-speed') || box.getAttribute('data-speed')) || 50;
      var draggable = box.hasAttribute('data-ss-drag') || box.hasAttribute('data-drag');
      var pauseHover = box.hasAttribute('data-pause-hover') || !draggable;
      var clones = [];
      var D = 0;
      var st = { view: true, hover: false, focus: false, held: false, drag: false };
      var dead = false;

      function originals() {
        var out = [];
        for (var i = 0; i < track.children.length; i++) {
          var li = track.children[i];
          if (li.getAttribute('aria-hidden') !== 'true') out.push(li);
        }
        return out;
      }
      function measure() {
        if (dead) return;
        var orig = originals();
        var kids = track.children;
        var n = orig.length;
        if (!n || kids.length < 2) return;
        var g = parseFloat(getComputedStyle(track).columnGap) || parseFloat(getComputedStyle(box).getPropertyValue('--g')) || 0;
        var d = kids.length > n ? kids[n].offsetLeft - kids[0].offsetLeft : track.scrollWidth + g;
        if (d <= 0) return;
        /* contenido suficiente: al menos el ancho visible + un periodo + gap */
        var need = box.clientWidth + d + g + 2;
        var guard = 0;
        while (track.scrollWidth < need && guard < 12) {
          orig.forEach(function (li) {
            var cl = li.cloneNode(true);
            cl.setAttribute('aria-hidden', 'true');
            cl.setAttribute('inert', '');
            cl.removeAttribute('id');
            cl.querySelectorAll('[id]').forEach(function (x) { x.removeAttribute('id'); });
            cl.querySelectorAll('a,button,[tabindex]').forEach(function (x) { x.setAttribute('tabindex', '-1'); });
            track.appendChild(cl);
            clones.push(cl);
          });
          guard++;
        }
        D = d;
        box.style.setProperty('--D', d.toFixed(3) + 'px');
        box.style.setProperty('--dur', (d / speed).toFixed(3) + 's');
        box.classList.add('is-ready');
        requestAnimationFrame(update);
      }
      function anim() {
        if (!track.getAnimations) return null;
        var list = track.getAnimations();
        for (var i = 0; i < list.length; i++) if (list[i].animationName === 'ss-tk') return list[i];
        return null;
      }
      function update() {
        var a = anim();
        if (!a) return;
        var run = st.view && !st.hover && !st.focus && !st.held && !st.drag && !reduced();
        if (run && a.playState !== 'running') a.play();
        else if (!run && a.playState === 'running') a.pause();
      }

      var io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) {
          st.view = es[es.length - 1].isIntersecting;
          update();
        }, { threshold: 0 });
        io.observe(box);
      }
      var ro = null;
      var roRaf = 0;
      var lastW = box.clientWidth;
      if ('ResizeObserver' in window) {
        ro = new ResizeObserver(function () {
          if (box.clientWidth === lastW) return;
          lastW = box.clientWidth;
          if (!roRaf) roRaf = requestAnimationFrame(function () { roRaf = 0; measure(); });
        });
        ro.observe(box);
      }

      /* pausas: hover (T0), foco dentro (todas), toque/clic (T0 alterna pausa: WCAG 2.2.2) */
      function onEnter(e) { if (pauseHover && e.pointerType === 'mouse') { st.hover = true; update(); } }
      function onLeave(e) {
        /* sin captura hasta que hay arrastre: si el puntero sale sin moverse, se suelta aquí */
        if (st.drag && !moved && e.pointerId === pid) onUp(e);
        if (e.pointerType === 'mouse') { st.hover = false; update(); }
      }
      function onFocusIn(e) {
        var t = e.target;
        var kb = true;
        try { kb = t.matches(':focus-visible'); } catch (err) { kb = true; }
        if (kb) { st.focus = true; update(); }
      }
      function onFocusOut(e) { if (!box.contains(e.relatedTarget)) { st.focus = false; update(); } }
      box.addEventListener('pointerenter', onEnter);
      box.addEventListener('pointerleave', onLeave);
      box.addEventListener('focusin', onFocusIn);
      box.addEventListener('focusout', onFocusOut);

      /* arrastre 1:1 (T1, T2, T3): congela mientras se sostiene, sin límites, no vuelve a su sitio */
      var startX = 0;
      var startT = 0;
      var moved = false;
      var pid = null;
      function durMs() { return D / speed * 1000; }
      function onDown(e) {
        if (!draggable) {
          if (e.pointerType !== 'mouse') { st.held = !st.held; update(); }
          return;
        }
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (reduced()) return;
        var a = anim();
        if (!a || !D) return;
        st.drag = true;
        update();
        startX = e.clientX;
        startT = a.currentTime || 0;
        moved = false;
        pid = e.pointerId;
        /* sin setPointerCapture aquí: con la captura activa Chromium manda el click al contenedor y la tarjeta
           (un <a>) no navega. La captura se toma en onMove, solo cuando ya hay arrastre real (> 4 px). */
        box.classList.add('is-grabbing');
      }
      function onMove(e) {
        if (!st.drag || e.pointerId !== pid) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) {
          if (!moved) { try { box.setPointerCapture(pid); } catch (err) { /* sin captura */ } }
          moved = true;
        }
        var a = anim();
        if (!a) return;
        var dm = durMs();
        var t = right ? startT + (dx / D) * dm : startT - (dx / D) * dm;
        t = ((t % dm) + dm) % dm + dm;
        a.currentTime = t;
      }
      function onUp(e) {
        if (!st.drag || (pid !== null && e.pointerId !== pid)) return;
        st.drag = false;
        try { box.releasePointerCapture(pid); } catch (err) { /* nada */ }
        pid = null;
        box.classList.remove('is-grabbing');
        update();
      }
      function onClickCapture(e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }
      function onDragStart(e) { e.preventDefault(); }
      box.addEventListener('pointerdown', onDown);
      box.addEventListener('pointermove', onMove);
      box.addEventListener('pointerup', onUp);
      box.addEventListener('pointercancel', onUp);
      box.addEventListener('click', onClickCapture, true);
      box.addEventListener('dragstart', onDragStart);

      measure();
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measure);
      window.addEventListener('load', measure, { once: true });

      register(box, 'tk', function () {
        dead = true;
        if (io) io.disconnect();
        if (ro) ro.disconnect();
        if (roRaf) cancelAnimationFrame(roRaf);
        box.removeEventListener('pointerenter', onEnter);
        box.removeEventListener('pointerleave', onLeave);
        box.removeEventListener('focusin', onFocusIn);
        box.removeEventListener('focusout', onFocusOut);
        box.removeEventListener('pointerdown', onDown);
        box.removeEventListener('pointermove', onMove);
        box.removeEventListener('pointerup', onUp);
        box.removeEventListener('pointercancel', onUp);
        box.removeEventListener('click', onClickCapture, true);
        box.removeEventListener('dragstart', onDragStart);
        clones.forEach(function (cl) { if (cl.parentNode) cl.parentNode.removeChild(cl); });
        clones = [];
        box.classList.remove('is-ready', 'is-grabbing');
      });
    });
  }

  /* ------------------------------------------------------------ acordeones */
  function accTiming(btn) {
    var faq = btn.getAttribute('data-ss-acc') === 'faq' || !!btn.closest('[data-ss-faq]');
    return faq
      ? { ms: 560, ease: cssVar('--ez-hover', 'cubic-bezier(0.16,1,0.30,1)') }
      : { ms: 525, ease: cssVar('--ez-critical', 'cubic-bezier(0.24,0.20,0.16,1)') };
  }
  function accPanel(btn) {
    var id = btn.getAttribute('aria-controls');
    var p = id ? doc.getElementById(id) : null;
    return p || btn.nextElementSibling;
  }
  window.ssAcc = function (btn) {
    if (!btn) return false;
    var panel = accPanel(btn);
    if (!panel) return false;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var row = btn.closest('[data-ss-acc-item]');
    if (row) row.classList.toggle('is-open', open);
    if (panel.__ssAccEnd) { panel.removeEventListener('transitionend', panel.__ssAccEnd); panel.__ssAccEnd = null; }
    if (reduced()) {
      panel.hidden = !open;
      panel.classList.toggle('is-open', open);
      panel.style.height = '';
      panel.style.overflow = '';
      panel.style.transition = '';
      return false;
    }
    var tm = accTiming(btn);
    var from;
    if (open) {
      panel.hidden = false;
      panel.classList.add('is-open');
      from = panel.style.height && panel.style.height !== 'auto' ? panel.getBoundingClientRect().height : 0;
    } else {
      from = panel.getBoundingClientRect().height;
    }
    var to = open ? panel.scrollHeight : 0;
    panel.style.overflow = 'hidden';
    panel.style.transition = 'none';
    panel.style.height = from + 'px';
    void panel.offsetHeight;
    panel.style.transition = 'height ' + tm.ms + 'ms ' + tm.ease;
    panel.style.height = to + 'px';
    var end = function (e) {
      if (e && e.target !== panel) return;
      panel.removeEventListener('transitionend', end);
      panel.__ssAccEnd = null;
      panel.style.transition = '';
      panel.style.overflow = '';
      panel.style.height = '';
      if (!open) { panel.hidden = true; panel.classList.remove('is-open'); }
    };
    panel.__ssAccEnd = end;
    panel.addEventListener('transitionend', end);
    setTimeout(function () { if (panel.__ssAccEnd === end) end(); }, tm.ms + 80);
    return false;
  };
  var accBound = false;
  function initAccDelegate() {
    if (accBound) return;
    accBound = true;
    doc.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-ss-acc]') : null;
      if (!btn || btn.hasAttribute('onclick')) return;
      e.preventDefault();
      window.ssAcc(btn);
    });
  }

  /* ------------------------------------------------------ init / teardown */
  function motionInit(root) {
    root = root || doc;
    initNav();
    initPos();
    initAccDelegate();
    [initReveals, initHero, initScrub, initTrack, initSeal, initMarquees].forEach(function (fn) {
      try { fn(root); } catch (err) { if (window.console) console.error('[ss-motion]', err); }
    });
  }
  function motionTeardown(root) {
    root = root || doc;
    var keep = [];
    registry.forEach(function (c) {
      if (root === doc || root === c.el || (root.contains && root.contains(c.el))) {
        try { c.stop(); } catch (err) { /* nada */ }
        unready(c.el, c.key);
      } else {
        keep.push(c);
      }
    });
    registry = keep;
  }
  window.ssMotionInit = motionInit;
  window.ssMotionTeardown = motionTeardown;

  /* envuelve ssInit / ssTeardown de ss-subscribe.js (carga antes) sin pisarlas; idempotente */
  function wrapHooks() {
    var pi = window.ssInit;
    if (!(pi && pi.__ssMotion)) {
      var wi = function (r) {
        if (typeof pi === 'function') { try { pi(r); } catch (err) { if (window.console) console.error('[ss-init]', err); } }
        motionInit(r);
      };
      wi.__ssMotion = true;
      window.ssInit = wi;
    }
    var pt = window.ssTeardown;
    if (!(pt && pt.__ssMotion)) {
      var wt = function (r) {
        if (typeof pt === 'function') { try { pt(r); } catch (err) { /* nada */ } }
        motionTeardown(r);
      };
      wt.__ssMotion = true;
      window.ssTeardown = wt;
    }
  }
  wrapHooks();
  doc.addEventListener('DOMContentLoaded', wrapHooks);
  window.addEventListener('load', wrapHooks);

  /* reduced-motion en vivo: se rehace todo */
  onMQ(RM, function () {
    motionTeardown(doc);
    motionInit(doc);
  });

  /* editor de temas */
  doc.addEventListener('shopify:section:load', function (e) { motionInit(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) { motionTeardown(e.target); });

  motionInit(doc);
})();
